import React from 'react';
import { useTranslate } from 'react-admin';
import { SelectInput } from 'react-admin';
import { useAllSolutions } from '~/hooks/useSolution';

export interface Props {
  source: string;
  label: string;
  className?: string;
  alwaysOn?: boolean;
  onChange?: (e: any) => void;
  validate?: any;
  allowEmpty?: boolean;
  helperText?: boolean;
  variant: 'all' | 'individual' | 'business';
}

const SolutionSelect = ({
  source,
  label,
  className,
  alwaysOn,
  onChange,
  validate,
  allowEmpty,
  helperText = false,
  variant = 'all',
}: Props) => {
  const { data: queryData, isLoading } = useAllSolutions();
  const translate = useTranslate();

  const data = Array.isArray(queryData?.data) ? queryData?.data : [];
  const solutions =
    variant === 'all'
      ? data
      : variant === 'individual'
      ? data?.filter((solution) => solution.features.includes('veengu_individual_profile'))
      : variant === 'business'
      ? data?.filter((solution) => solution.features.includes('veengu_business_profile'))
      : [];
  const choices =
    solutions?.map((solution) => {
      return {
        id: solution.id,
        name: solution.name,
      };
    }) ?? [];

  allowEmpty && choices.unshift({ id: '', name: translate('utils.any') });
  return (
    <SelectInput
      choices={choices}
      className={className}
      source={source}
      label={label}
      helperText={helperText}
      allowEmpty={false}
      defaultValue=''
      alwaysOn={alwaysOn}
      onChange={onChange}
      validate={validate}
      loading={isLoading}
    />
  );
};

export default SolutionSelect;
